import { Injectable } from "@angular/core";
import { CaisseComponent } from "./caisse.component";

@Injectable({ providedIn: 'root' })
export class CaisseStateService {
    CaisseComponent: CaisseComponent;

    setPreviousState(CaisseComponent: CaisseComponent) {
        var propNames = Object.getOwnPropertyNames(this.CaisseComponent);
        var propertiesToIgnore = [
            "router", "generalService", "CaisseStateService", "api", "stepper", "__ngContext__", "imgKastelo",
            "frmlisteStock", "frmDialogModePayement", "frmEchange", "frmListeArticle", "frmListeClient",
            "frmRemiseArticle", "frmSoldeCaisseOuverture", "frmlisteStock"
        ];

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            if (!propertiesToIgnore.includes(element)) {
                CaisseComponent[element] = this.CaisseComponent[element];
            }
        }
    }
}